<script setup>
import {
    ref,
    getCurrentInstance
} from 'vue'
import {
    DriverStore
} from '../pinia/Driver.js'
const Driver = DriverStore()

const {
    proxy
} = getCurrentInstance()
const premium = ref(false)
const crew = ref(false)

async function unlinkdiscord() {
    const res = await proxy.$api({
        serviceName: "account",
        methodName: "unlinkdiscord"
    })
    Driver.user.discord = null
}

async function getRolePremium() {
    premium.value = true
    premium.value = await getRole('premium')
}

async function getRoleCrew() {
    crew.value = true
    crew.value = await getRole('crew')
}

async function getRole(role) {
    const res = proxy.$api({
        serviceName: "account",
        methodName: "getRole",
        parameters: [role]
    })
    return false
}
</script>

<template>
<div class="discordForm">
    <v-container>
        <div class="settings-card">
            <div class="settings-card-header">
                <div class="header-icon">
                    <v-icon size="28">mdi-discord</v-icon>
                </div>
                <div class="header-content">
                    <h3 class="settings-title">Discord Integration</h3>
                    <p class="settings-subtitle" v-if="Driver.user.discord != null">
                        Connected as {{ Driver.user.discord_name }}
                    </p>
                    <p class="settings-subtitle" v-else>
                        Link your Discord account to unlock special features
                    </p>
                </div>
            </div>

            <div class="settings-card-body">
                <!-- Not Connected State -->
                <div v-if="Driver.user.discord == null" class="discord-not-connected">
                    <div class="info-box">
                        <v-icon size="64">mdi-link-variant-off</v-icon>
                        <p class="info-text">Your Discord account is not linked yet</p>
                    </div>
                    <a onclick="open('https://api.nightriderz.world/discord-moonset.php?key=' + localStorage.getItem('easharpptr_u'), 'Discord', 'scrollbars=1,resizable=1,height=700,width=500')">
                        <v-btn variant="tonal" color="primary" size="large">
                            <v-icon class="mr-2">mdi-discord</v-icon>
                            Login with Discord
                        </v-btn>
                    </a>
                </div>

                <!-- Connected State -->
                <div v-else>
                    <!-- Discord Username -->
                    <div class="setting-item">
                        <div class="setting-info full-width">
                            <div class="setting-label">
                                <v-icon size="20" class="mr-2">mdi-account-cog</v-icon>
                                Discord Account
                            </div>
                            <div class="setting-description">
                                Your linked Discord account
                            </div>
                            <v-text-field 
                                prepend-icon="mdi-discord" 
                                v-model="Driver.user.discord_name" 
                                label="Discord" 
                                variant="outlined"
                                disabled
                                density="comfortable"
                                hide-details
                                class="setting-input"
                            ></v-text-field>
                        </div>
                    </div>

                    <v-divider class="my-4"></v-divider>

                    <!-- Discord Roles -->
                    <div class="setting-item">
                        <div class="setting-info full-width">
                            <div class="setting-label">
                                <v-icon size="20" class="mr-2">mdi-shield-star</v-icon>
                                Discord Roles
                            </div>
                            <div class="setting-description">
                                Click on the roles to enable them on Discord
                            </div>
                            
                            <div class="roles-container">
                                <v-btn 
                                    v-if="Driver.user.premium" 
                                    :loading="premium" 
                                    :disabled="premium" 
                                    @click="getRolePremium" 
                                    variant="tonal"
                                    class="role-btn"
                                >
                                    <span class="role-dot premium-dot">●</span> Premium
                                </v-btn>
                                
                                <v-btn 
                                    v-if="Driver.currentCrew && Driver.currentCrew.ownerUserId == Driver.persona.ID" 
                                    :loading="crew" 
                                    :disabled="crew" 
                                    @click="getRoleCrew" 
                                    variant="tonal"
                                    class="role-btn"
                                >
                                    <span class="role-dot crew-dot">●</span> Crew Owner
                                </v-btn>
                            </div>
                        </div>
                    </div>

                    <v-divider class="my-4"></v-divider>

                    <!-- Unlink Account -->
                    <div class="setting-item">
                        <div class="setting-info full-width">
                            <div class="setting-label">
                                <v-icon size="20" class="mr-2">mdi-link-variant-off</v-icon>
                                Manage Connection
                            </div>
                            <div class="setting-description">
                                Remove the link between your Discord and NightRiderz accounts
                            </div>
                            <v-btn 
                                @click="unlinkdiscord" 
                                variant="tonal" 
                                color="error"
                            >
                                <v-icon class="mr-2">mdi-link-variant-off</v-icon>
                                Unlink my account
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-container>
</div>
</template>

<style scoped>
.discordForm {
    margin: 0;
    padding: 0;
}

.discordForm .v-icon {
    color: currentColor;
    opacity: 1;
}

.settings-card {
    background: rgba(255, 255, 255, 0.03);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    overflow: hidden;
    margin-bottom: 20px;
}

.settings-card-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px;
    background: rgba(var(--v-theme-primary), 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.header-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: rgba(var(--v-theme-primary), 0.2);
    border-radius: 10px;
}

.header-icon .v-icon {
    color: rgb(var(--v-theme-primary));
}

.header-content {
    flex: 1;
}

.settings-title {
    margin: 0;
    font-size: 1.3em;
    font-weight: 600;
    color: rgb(var(--v-theme-primary));
}

.settings-subtitle {
    margin: 4px 0 0 0;
    font-size: 0.85em;
    color: rgba(255, 255, 255, 0.6);
}

.settings-card-body {
    padding: 24px;
}

.setting-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.setting-info {
    flex: 1;
}

.setting-info.full-width {
    width: 100%;
}

.setting-label {
    display: flex;
    align-items: center;
    font-size: 1em;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 6px;
}

.setting-label .v-icon {
    color: rgba(255, 255, 255, 0.9);
}

.setting-description {
    font-size: 0.85em;
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 16px;
}

.setting-input {
    margin-top: 0;
}

.discord-not-connected {
    text-align: center;
}

.info-box {
    padding: 30px;
    margin-bottom: 20px;
}

.info-box .v-icon {
    color: rgba(255, 255, 255, 0.3);
}

.info-text {
    font-size: 0.95em;
    color: rgba(255, 255, 255, 0.6);
    margin: 0;
}

.roles-container {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.role-btn {
    flex: 1;
    min-width: 200px;
}

.role-dot {
    font-size: 1.5rem;
    margin-right: 8px;
    line-height: 1;
}

.premium-dot {
    color: #f0ab00;
}

.crew-dot {
    color: #3ba370;
}
</style>
